import "./style/index.scss";
import { LeftOutlined, CheckOutlined } from "@ant-design/icons";
import { Button, Checkbox, Col, Divider, Flex, Form, Input, Row, Space, Tree } from "antd";
import Search from "antd/es/input/Search";
import Transfer, { TransferItem } from "antd/es/transfer";
import { useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import { DataNode } from "../../../../models/treeModel";
import { setTitle } from "../../../../redux/slices/configuracoes/configuracoesSlice";
import { buscarCentroCusto } from "../../../../services/centroCustoService";
import { atualizarRateioCentroCusto, cadastrarRateioCentroCusto } from "../../../../services/rateioCentroCustoService";
import { formatPercent, percentParaNumber } from "../../../../util/dinheiroBRAuxiliar";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { setPageRateioCentroCusto } from "../../../../redux/slices/rateioCentroCusto/rateioCentroCustoSlice";
import { toastWarning } from "../../../../util/toast";

const CadastrarPage = () => {
  //estados globais
  const rateioCentroCustoState = useAppSelector((state) => state.rateioCentroCusto);
  const centroCustoState = useAppSelector((state) => state.centroCusto);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();

  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
  const [selectSource, setselectSource] = useState<string[]>([]);
  const [check, setCheck] = useState<any[] | string[]>([]);
  const [targetNode, setTargetNode] = useState<DataNode[]>([]);
  const [checkGroup, setCheckGroup] = useState<any[] | number[]>([]);
  const [targetKeys, setTargetKeys] = useState<string[]>([]);

  const editar = Object.values(rateioCentroCustoState.entity).length !== 0;

  const inputInicial = useRef<any>();

  useEffect(() => {
    if (inputInicial.current && !editar) {
      inputInicial.current.focus();
    }
    dispatch(buscarCentroCusto({ ...centroCustoState.busca, pesquisar: null }));
    if (editar) {
      dispatch(setTitle("EDITAR RATEIO DE CENTRO DE CUSTO"));
      form.setFieldsValue({ ...rateioCentroCustoState.entity });
      var keys: any[] = [];
      var totalRatEdit = 0;
      rateioCentroCustoState.entity.jsonDetalheCentroCusto?.forEach((a: any) => {
        keys.push(a.idCentroCusto);
        totalRatEdit += a.porcentagem;
        form.setFieldValue(`${a.idCentroCusto}inputNumber`, formatPercent(a.porcentagem));
      });
      handleChanges(keys, "right", keys);
      form.setFieldValue("totalRateio", formatPercent(totalRatEdit));
    } else {
      dispatch(setTitle("NOVO RATEIO DE CENTRO DE CUSTO"));
      form.setFieldValue("ativo", true);
    }
  }, []);

  const searchId = () => {
    //await dispatch(buscarCentroCusto({ ...centroCustoState.busca, pesquisar: null }));
    const lista: DataNode[] = [];
    const testeSearch = (treeNodes: DataNode[] = []) =>
      treeNodes.filter(({ filhos, ...props }: any) => {
        if (filhos.length === 0) {
          filhos = undefined;
        }
        lista.push(props);
        testeSearch(filhos);
        return { ...props };
      });
    testeSearch(centroCustoState.list);
    return lista;
  };

  const handleChanges = (keys: any[], direction: string, moveKeys: any) => {
    setTargetKeys(keys);
    let nodes: any = [];
    keys.forEach((a: any) => {
      searchId().forEach((b: any) => {
        if (b.id === a) {
          nodes.push(b);
        }
      });
    });
    setTargetNode(nodes.reverse());
    if (direction === "left") {
      const searchEqualCheck = moveKeys.some((el: any) => checkGroup.includes(el));
      if (searchEqualCheck) {
        moveKeys.forEach((move: any) => {
          if (checkGroup.includes(move)) {
            const indice = checkGroup.indexOf(move);
            checkGroup.splice(indice, 1);
          }
        });
        targetNode.forEach((node: any) => {
          if (moveKeys.includes(node.id)) {
            form.setFieldValue(`${node.id}inputNumber`, "");
          }
        });
        form.setFieldValue("totalRateio", manutencaoRateio("soma"));
        form.setFieldValue("check", checkGroup);
      }
    }
  };

  const manutencaoRateio = (tipo: string) => {
    const entriesValues = Object.entries(form.getFieldsValue());
    const filterItem = entriesValues.filter((v: any) => typeof v[1] === "string" && v[1].includes("%") && v[0] !== "denominacao");
    let somaRateio = 0;
    switch (tipo) {
      case "soma":
        filterItem.forEach((value: any) => (somaRateio = somaRateio + parseInt(value[1].replace("%", ""))));
        return somaRateio;
      case "setTotal":
        let teste: any[] = [];
        filterItem.forEach((value: any) =>
          teste.push({
            idCentroCusto: parseInt(value[0].replace("inputNumber", "")),
            idPlanoContaFinanceiro: 0,
            valor: percentParaNumber(value[1]),
          })
        );
        return teste;
    }
    return somaRateio;
  };

  const handleFormChange = () => {
    const somaTotal = manutencaoRateio("soma");
    form.setFieldsValue({ totalRateio: somaTotal });
  };

  const submit = (values: any) => {
    const somaTotal = manutencaoRateio("soma");
    if (somaTotal !== 100) {
      toastWarning("Porcentagens devem somar 100%!");
    } else {
      const total = manutencaoRateio("setTotal");
      const newValues = {
        id: null,
        denominacao: values.denominacao,
        ativo: values.ativo,
        automatico: false,
        detalhes: total,
      };

      if (editar) {
        dispatch(atualizarRateioCentroCusto({ value: { ...newValues, id: rateioCentroCustoState.entity.id }, busca: rateioCentroCustoState.busca }));
      } else {
        dispatch(cadastrarRateioCentroCusto({ value: newValues, busca: rateioCentroCustoState.busca }));
      }
    }
  };

  const generateTree = (treeNodes: DataNode[] = [], checkedKeys: string[] = []): DataNode[] =>
    treeNodes.map(({ filhos, ...props }: any) => {
      if (filhos.length === 0) {
        filhos = undefined;
      }
      return {
        ...props,
        disabled: filhos !== undefined || checkedKeys.includes(props.id as string) || !props.ativo || props.sinteticoAnalitico === "S",
        filhos: generateTree(filhos, checkedKeys),
      };
    });

  const selectItemChange = (sourceSelectedKeys: any[], targetSelectedKeys: any[]) => {
    setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
    setselectSource(sourceSelectedKeys);
    if (!targetSelectedKeys.includes(check)) {
      setCheck(targetSelectedKeys);
    }
  };

  const changeCheckbox = (value: any) => {
    let arr: any[] = [];
    if (check.includes(value)) {
      const checkboxCheck = check;
      const indc = checkboxCheck.indexOf(value);
      checkboxCheck.splice(indc, 1);
      arr = checkboxCheck;
      setCheck(checkboxCheck);
    } else {
      const checkBoxChecks = [value, ...check];
      arr = checkBoxChecks;
      setCheck(checkBoxChecks);
    }
    selectItemChange(selectSource, arr);
  };

  const onSearch = async (value: string) => {
    var busca = { ...centroCustoState.busca };
    busca.pesquisar = value;
    await dispatch(buscarCentroCusto(busca));
  };

  const isChecked = (selectedKeys: (string | number)[], eventKey: string | number) => selectedKeys.includes(eventKey);

  const transferDataSource: TransferItem[] = [];

  const flatten = (list: DataNode[] = []) => {
    list.forEach((item) => {
      transferDataSource.push(item as TransferItem);
      if (item.filhos === null) {
        flatten(undefined);
      } else {
        flatten(item.filhos);
      }
    });
  };

  flatten(centroCustoState.list);

  const voltar = () => {
    dispatch(setTitle("RATEIOS DE CENTRO DE CUSTO"));
    dispatch(setPageRateioCentroCusto("geral"));
  };

  return (
    <Flex gap={12} style={{ overflow: "hidden" }} vertical>
      <Flex onClick={voltar} className="voltar">
        {"<"} VOLTAR
      </Flex>
      <Form form={form} layout="vertical" onFinish={submit} onChange={handleFormChange}>
        <Row gutter={12} style={{ width: 1800 }}>
          <Col span={6}>
            <Form.Item
              label="Descrição"
              name="denominacao"
              rules={[
                {
                  required: true,
                  message: "Digite a denominação",
                },
              ]}
            >
              <Input type="text" disabled={editar && rateioCentroCustoState.entity.automatico ? true : false} />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label=" " name="ativo" valuePropName="checked">
              <Checkbox name="ativo" style={{ fontSize: "14px", paddingTop: "5px" }} disabled={Boolean(editar && rateioCentroCustoState.entity.automatico)}>
                Ativo
              </Checkbox>
            </Form.Item>
          </Col>
        </Row>
        <Divider orientation="left" orientationMargin="0">
          Composição
        </Divider>
        <Row gutter={12} align="bottom">
          <Col span={18}>
            <Transfer
              targetKeys={targetKeys}
              dataSource={transferDataSource}
              className="tree-transfer"
              render={(item) => item.denominacao}
              showSelectAll={false}
              rowKey={(record) => record.id}
              onSelectChange={selectItemChange}
              selectedKeys={selectedKeys}
              onChange={handleChanges}
              titles={["", "Composição do rateio"]}
              selectAllLabels={[
                ({ selectedCount, totalCount }) => (
                  <span className="searchTransfer">
                    <p>Selecione os itens que irão compor o rateio </p>
                    <Search allowClear placeholder="Pesquisar Item" onSearch={onSearch} className="searchInput transfer" enterButton />
                  </span>
                ),
              ]}
            >
              {({ direction, onItemSelect, selectedKeys }) => {
                if (direction === "left") {
                  let checkedKeys = [...selectedKeys, ...targetKeys];
                  return (
                    <div>
                      <Tree
                        checkable
                        checkStrictly
                        defaultExpandAll
                        checkedKeys={checkedKeys}
                        fieldNames={{
                          title: "denominacao",
                          key: "id",
                          children: "filhos",
                        }}
                        treeData={generateTree(centroCustoState.list, targetKeys)}
                        onCheck={(_, { node: { id } }: any) => {
                          onItemSelect(id as string, !isChecked(checkedKeys as (string | number)[], id));
                        }}
                        onSelect={(_, { node: { id } }: any) => {
                          onItemSelect(id as string, !isChecked(checkedKeys as (string | number)[], id));
                        }}
                        disabled={editar && rateioCentroCustoState.entity.automatico ? true : false}
                      />
                    </div>
                  );
                }
                if (direction === "right") {
                  return (
                    <>
                      <Form.Item name="check">
                        <Checkbox.Group onChange={(value: any) => setCheckGroup(value)} style={{ gap: 10 }} disabled={editar && rateioCentroCustoState.entity.automatico ? true : false}>
                          {targetNode.map((item: any) => {
                            return (
                              <Flex align="baseline" key={item.id}>
                                <Checkbox value={item.id} name={item.denominacao} onChange={() => changeCheckbox(item.id)} key={item.id} className="checkboxRight">
                                  <Flex align="baseline" gap={10}>
                                    <Form.Item name={`${item.id}inputNumber`} style={{ marginBottom: 0 }}>
                                      <NumericFormat
                                        className="ant-input checkboxColorBorder number-input"
                                        style={{
                                          width: "80px",
                                          height: "32px",
                                        }}
                                        decimalSeparator=","
                                        decimalScale={2}
                                        suffix="%"
                                        fixedDecimalScale={true}
                                        placeholder="0,00%"
                                        disabled={editar && rateioCentroCustoState.entity.automatico ? true : false}
                                      />
                                    </Form.Item>
                                    <span className="labelRateio">{item.denominacao}</span>
                                  </Flex>
                                </Checkbox>
                              </Flex>
                            );
                          })}
                        </Checkbox.Group>
                      </Form.Item>
                      <Divider />
                      <div className="totalRateio">
                        {/* <Divider className="dividerTotal"></Divider> */}
                        <div className="totalRateioLabel">
                          <span className="labelRateio">Total do rateio</span>
                          <Form.Item name="totalRateio">
                            <NumericFormat
                              className="ant-input noBoderColor number-input"
                              style={{
                                width: "80px",
                                height: "32px",
                                marginRight: "10px",
                              }}
                              decimalSeparator=","
                              decimalScale={2}
                              suffix="%"
                              fixedDecimalScale={true}
                              disabled
                              placeholder="0,00%"
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </>
                  );
                }
              }}
            </Transfer>
          </Col>
        </Row>
        <Divider />
        <Row gutter={12}>
          <Col span={24} className="modalFooter">
            <Space size="middle">
              <Button className="cancelButton" onClick={voltar} icon={<LeftOutlined />}>
                VOLTAR
              </Button>
              <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
                {editar ? "ATUALIZAR" : "SALVAR"}
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Flex>
  );
};

export default CadastrarPage;
